import { FETCH_MIPS_START, FETCH_MIPS_SUCCESS, FETCH_MIPS_ERROR, ADD_MIP_SUCCESS, ADD_MIP_ERROR, UPDATE_MIP_SUCCESS, UPDATE_MIP_ERROR, FETCH_ALL_MIP_MACHINES_SUCCESS, FETCH_ALL_MIP_MACHINES_ERROR, ADD_UPDATE_MIP_MACHINE_SUCCESS, DELETE_MIP_MACHINE_SUCCESS, RESET_MIP_MACHINES, SET_MIPS_PAGINATION } from '../../actions/admin/mipsAction';
import { paginationSize } from '../../../constants/constants';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    mips: [],
    mipMachines: [],
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
};

const mipsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newMips;
    let index;
    switch (action.type) {
        case FETCH_MIPS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_MIPS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, mips: action.mips };
        }
        case FETCH_MIPS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SET_MIPS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case ADD_MIP_SUCCESS: {
            newState = { ...state }
            newMips = [...newState.mips];
            newMips.push(action.mip);
            newState.mips = [...newMips];
            return newState;
        }
        case ADD_MIP_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case UPDATE_MIP_SUCCESS: {
            newState = { ...state }
            newMips = [...newState.mips];
            index = newMips.findIndex(mip => mip.mipId === action.mip.mipId);

            if (index > -1) {
                newMips.splice(index, 1, action.mip);
            }
            newState.mips = [...newMips];
            return newState;
        }
        case UPDATE_MIP_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case FETCH_ALL_MIP_MACHINES_SUCCESS: {
            return { ...state, loading: false, mipMachines: action.mipMachines.length > 0 ? [...action.mipMachines] : [] };
        }
        case FETCH_ALL_MIP_MACHINES_ERROR: {
            return { ...state, loading: false, mipMachines: [] };
        }
        case ADD_UPDATE_MIP_MACHINE_SUCCESS: {
            newState = { ...state }
            index = newState.mipMachines.findIndex(machine => machine.machineId === action.mipMachine.machineId);
            if (index > -1) {
                newState.mipMachines[index] = { ...action.mipMachine }
            } else {
                newState.mipMachines.push(action.mipMachine)
            }
            return { ...newState };
        }

        case DELETE_MIP_MACHINE_SUCCESS: {
            let mipMachines = state.mipMachines.filter(machine => machine.machineId !== action.payload.machineId);
            return { ...state, mipMachines: [...mipMachines] };
        }

        case RESET_MIP_MACHINES: {
            newState = { ...state }
            newState.mipMachines = []
            return { ...newState }
        }

        default:
            return state;
    }
}

export default mipsReducer;
